import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { getPackageForChart } from '../../google-charts-helper';
import { GoogleChartType } from '../../google-charts-type';
import { GoogleChartBaseComponent } from '../chart-base.component';
declare const google: any;

@Component({
    selector: 'app-google-combochart',
    templateUrl: './google-combochart.component.html',
    styleUrl: './google-combochart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoogleCombochartComponent extends GoogleChartBaseComponent implements OnInit {
    @ViewChild('chartContainer', { read: ElementRef })
    private containerEl: ElementRef<HTMLElement>;
    chartType = GoogleChartType.ComboChart;

    private hasBeenDrawn: boolean = false;

    private chartImgSubj: Subject<{ chartName: string; imgUri: string }> = new Subject<{ chartName: string; imgUri: string }>();
    public chartImg$ = this.chartImgSubj.asObservable();

    @Input()
    set data(val: Array<Array<any>>) {
        if (val && val.length > 0) {
            this.chartData.next(val);
        }
    }

    @Input()
    set options(val: Record<string, any>) {
        if (val) {
            this.chartOptions.next(val);
        }
    }

    @Input()
    chartName: string = '';

    ngOnInit(): void {
        const chartPackage = getPackageForChart(this.chartType);

        combineLatest([this.chartData$, this.chartOptions$, this.loadChartPackage(chartPackage)]).subscribe(([data, options, _null]) => {
            if (data && options) {
                this.chart = new google.visualization.ComboChart(this.containerEl.nativeElement);
                this.drawChart(data, options);

                if (data.length === 0 || this.chartName?.length === 0 || this.hasBeenDrawn) return;
                // Vid första uppritningen (standardvärden före ev filtrering) skapar vi en bild av charten och skickar den till parenten.
                // Bilden ska användas i powerpoint exporten.

                this.drawHighResChart(data, options);
            }
        });
    }

    private drawHighResChart(data: any[][], options: Record<string, any>): void {
        if (!data || data.length === 0 || !options) return;
        this.hasBeenDrawn = true;

        const optionsCopy = structuredClone(options);

        // Skapa en osynlig div för högupplöst rendering
        const tempDiv = document.createElement('div');
        tempDiv.style.width = '1375px';
        tempDiv.style.height = '740px';
        tempDiv.style.position = 'absolute';
        tempDiv.style.left = '-9999px';
        document.body.appendChild(tempDiv);

        // Rendera i fast upplösning för att passa i PowerPoint
        optionsCopy.width = 1375;
        optionsCopy.height = 740;

        const chartHighRes = new google.visualization.ComboChart(tempDiv);
        this.drawChart(data, optionsCopy, chartHighRes);

        google.visualization.events.addListener(chartHighRes, 'ready', () => {
            const imgUri = chartHighRes.getImageURI();
            if (imgUri && imgUri.length > 0 && this.chartName?.length > 0) {
                const retObj = {
                    chartName: this.chartName,
                    imgUri: imgUri
                };
                this.chartImgSubj.next(retObj);
            }

            // Ta bort den tillfälliga dolda div:en
            document.body.removeChild(tempDiv);
        });
    }
}
